<div class="product-review" *ngIf="categoryName && productReviews.length > 0 && (!isParent || subRegionName)">
  <h2 class="product-review_title">Top Reviews of {{ categoryName }} {{ subRegionName ? "near you in " + subRegionName
    : "" }}</h2>
  <div class="reviews">
    <ng-container *ngIf="withCarousel">
      <app-my-carousel-swiper [config]="carouselOptionsLogos">
        <ng-container *ngFor="let review of productReviews">
          <div class="swiper-slide">
            <ng-container *ngTemplateOutlet="reviewItemTemplate; context: { $implicit: review }"></ng-container>
          </div>
        </ng-container>
      </app-my-carousel-swiper>
    </ng-container>
    <ng-container *ngIf="!withCarousel">
      <div class="row">
        <ng-container *ngFor="let review of productReviews">
          <div class="col-md-4 mb-3">
            <ng-container *ngTemplateOutlet="reviewItemTemplate; context: { $implicit: review }"></ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #reviewItemTemplate let-review>
  <div class="review-item">
    <div class="review-body">
      <div class="review-footer pb-3" *ngIf="review.memberShopProduct" (click)="openProduct(review.memberShopProduct)">
        <img [src]="imgUrl + review.memberShopProduct?.memberShopProductsImages[0]?.image"
          (error)="commonService.handleError($event)" alt="Product Image" class="product-image">
        <div class="d-flex flex-column">
          <div class="product-name">
            {{ review.memberShopProduct?.name }}
          </div>
          <small class="company-name text-muted">
            {{ review.memberShopProduct?.companyName }}
          </small>
        </div>
      </div>
      <div class="review-header">
        <div class="reviewer-info">
          <img src="assets/images/w.jpeg" alt="User Avatar" class="avatar" />
          <div class="name-date">
            <div class="name">{{ review.appUser.profileCharacterName || "Unknown" }}</div>
            <div class="date">{{ review.createdAt | date : "MMM d, yyyy" }}</div>
          </div>
        </div>
        <div class="rating">
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
          <i class="fas fa-star"></i>
        </div>
      </div>
      <div class="review-content">
        {{ review.message }}
      </div>
    </div>
  </div>
</ng-template>